/**
 * Hostname-aware routing helpers.
 * Used so a single deployed app can serve different domains differently.
 */

export function getHost() {
  if (typeof window === "undefined") return "";
  return window.location.hostname.toLowerCase();
}

export function isWynnHost() {
  const h = getHost();
  return h === "wynn.art" || h === "www.wynn.art";
}
